import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { CartProvider } from "@/context/CartContext";
import { Toaster } from "@/components/ui/sonner";
import BackgroundFX from "@/components/BackgroundFX";
import Preloader from "@/components/Preloader";
import Navbar from "@/components/Navbar";
import { usePromo } from "@/components/PromoBanner";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import AboutPage from "@/pages/AboutPage";
import CommunityPage from "@/pages/CommunityPage";
import ProductDetail from "@/pages/ProductDetail";
import BundlesPage from "@/pages/BundlesPage";
import BundleDetail from "@/pages/BundleDetail";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import PaymentCancel from "@/pages/PaymentCancel";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/AdminLogin";
import AdminOrders from "@/pages/AdminOrders";
import AdminAnalytics from "@/pages/AdminAnalytics";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!window.location.hash) window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const AppShell = () => {
  const { pathname } = useLocation();
  const isHome = pathname === "/";
  const isAdmin = pathname.startsWith("/control");
  const { active: promoActive } = usePromo(false);

  if (isAdmin) {
    return (
      <>
        <ScrollToTop />
        <Routes>
          <Route path="/control" element={<AdminLogin />} />
          <Route path="/control/orders" element={<AdminOrders />} />
          <Route path="/control/analytics" element={<AdminAnalytics />} />
          <Route path="/control/*" element={<Navigate to="/control/orders" replace />} />
        </Routes>
        <Toaster position="top-right" theme="light" richColors />
      </>
    );
  }

  return (
    <>
      <BackgroundFX />
      <ScrollToTop />
      <Navbar />
      <CartDrawer />
      <main className={isHome ? "" : promoActive ? "pt-[100px]" : "pt-16"}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/community" element={<CommunityPage />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/bundles" element={<BundlesPage />} />
          <Route path="/bundle/:id" element={<BundleDetail />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/order/:id" element={<OrderConfirmation />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <Toaster position="top-right" theme="light" richColors />
    </>
  );
};

function App() {
  return (
    <div className="App min-h-screen">
      <Preloader />
      <BrowserRouter>
        <CartProvider>
          <AppShell />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
